import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import {
  InterceptorUtil,
  LoggerService,
  OccEndpointsService,
  USE_CLIENT_TOKEN,
  normalizeHttpError,
} from '@spartacus/core';
import { Observable, of, throwError } from 'rxjs';
import { catchError, startWith } from 'rxjs/operators';
import { ProductModelSearchAdapter } from './product-model-search.adapter';
import { ManualsSearchResults } from '../../model/product.model';

@Injectable({
  providedIn: 'root',
})
export class OccProductModelSearchAdapter implements ProductModelSearchAdapter {
  protected logger = inject(LoggerService);

  constructor(
    protected http: HttpClient,
    protected occEndpoints: OccEndpointsService
  ) {}

  suggest(insertedModelMark: string): Observable<string> {
    const url: string = this.occEndpoints.buildUrl('productModelSearchSuggest');

    let headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
    });
    headers = InterceptorUtil.createHeader(USE_CLIENT_TOKEN, true, headers);

    const httpParams: HttpParams = new HttpParams().set('insertedModelMark', insertedModelMark);

    return this.http
      .post(url, httpParams, { headers, responseType: 'text' })
      .pipe(catchError((error) => throwError(normalizeHttpError(error, this.logger))));
  }

  find(insertedModelMark: string): Observable<string> {
    const url: string = this.occEndpoints.buildUrl('productModelSearchFind');

    let headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
    });
    headers = InterceptorUtil.createHeader(USE_CLIENT_TOKEN, true, headers);

    const httpParams: HttpParams = new HttpParams().set('insertedModelMark', insertedModelMark);

    return this.http
      .post(url, httpParams, { headers, responseType: 'text' })
      .pipe(catchError((error) => throwError(normalizeHttpError(error, this.logger))));
  }

  public findManuals(query: string): Observable<ManualsSearchResults> {
    const url = this.occEndpoints.buildUrl('products/manuals/search', { queryParams: { query } });

    return this.http.get<ManualsSearchResults>(url).pipe(
      startWith({ loading: true, notSubmited: true }),
      catchError(() => of({ loading: false, notSubmited: false }))
    );
  }
}
